var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-expansion-panel',[_c('expansion-header',{attrs:{"text":_vm.$t('coastMenu.waveData')}}),_c('v-expansion-panel-content',[_c('near-real-time',{attrs:{"station-list":_vm.stationList,"parameter-list":_vm.parameterList}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }